<template>
    <div id="relatorioGestao">
        <b-form @submit.stop.prevent="onSubmit">
            <b-card :class="{ 'm-3': !modal }" no-body>
                <template #header>
                    <h6 class="mb-0 d-flex justify-content-between">
                        <span class="titulo-sagres font-weight-bold">{{ titulo }}</span>
                        <b-button v-if="modal" @click="$emit('fecharModal')">
                            <font-awesome-icon icon="times" />
                        </b-button>
                        <b-button v-else class="mr-2" size="md" variant="secondary" type="submit" :disabled="loading">
                            <font-awesome-icon icon="file-alt" class="mr-2" />
                            Gerar Relatório
                        </b-button>
                    </h6>
                </template>
                <b-overlay :show="loading" rounded="sm">
                    <div class="filtros-relatorio m-2">
                        <slot></slot>
                    </div>
                </b-overlay>
            </b-card>
        </b-form>
        <pdf-viewer v-if="!loading && pdfObj" :data="pdfObj" :filename="filename" />
    </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import PdfViewer from '@/components/PdfViewer.vue'

const CompProps = Vue.extend({
    name: 'RelatorioGestao',
    components: { PdfViewer },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Relatório'
        },
        gerarRelatorio: {
            type: Function,
        },
        pdfData: {
            type: String,
            default: ''
        },
        modal: {
            type: Boolean,
            default: false
        }
    }
})

@Component
export default class RelatorioGestao extends mixins(UtilsTS, CompProps) {
    pdfObj: any = ''
    filename = ''

    async onSubmit(): Promise<void> {
        this.limparLocais()
        await this.gerarRelatorio()
    }

    limparLocais() {
        this.pdfObj = ''
        this.filename = ''
    }

    @Watch('pdfData')
    gerarPdfObj(newV) {
        try {
            if (newV && newV.length > 0) {
                const blob = this.base64ToPdf(newV)
                const objectUrl = URL.createObjectURL(blob)
                this.filename = `${this.titulo}_${new Date().toLocaleTimeString()}`
                this.pdfObj = objectUrl;
            } else {
                this.limparLocais()
            }
        } catch (e: any) {
            this.tratarError(e)
            this.limparLocais()
        }
    }
}
</script>

<style scoped></style>